import { useState } from 'react';
import { Tabs, TabList, TabPanel, Tab, Key } from 'react-aria-components';
import { Control, UseFormRegister, FieldErrors, FieldValues } from 'react-hook-form';

import { AppendixForm } from './AppendixForm';
import { BasicInfoForm } from './BasicInfoForm';

import Button from '@/components/Button/Button';

type FormContainerProps<T extends FieldValues> = {
  register: UseFormRegister<T>;
  control: Control<T>;
  errors: FieldErrors<T>;
  isValid: boolean;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
  childName: string;
  creatorName: string;
  isEdit: boolean;
  isDraft?: boolean;
  onShare?: () => void;
};

export function FormContainer<T extends FieldValues>({
  register,
  control,
  errors,
  isValid,
  onSubmit,
  onCancel,
  childName,
  creatorName,
  isEdit,
  isDraft,
  onShare,
}: FormContainerProps<T>) {
  const [tabKey, setTabKey] = useState<Key>('basic-info');

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault(); // デフォルトのフォーム送信を防止
    console.log('フォーム送信処理が実行されました');
    onSubmit(event);
  };

  return (
    <>
      {/* <div className="mb-4 bg-gray-100 p-2 text-xs">
        <p>バリデーション状態: {isValid ? '有効' : '無効'}</p>
        <p>エラー件数: {Object.keys(errors).length}</p>
        {Object.keys(errors).length > 0 && (
          <div>
            <p>エラー一覧:</p>
            <ul>
              {Object.entries(errors).map(([key, error]) => (
                <li key={key}>
                  {key}: {error?.message?.toString() || 'エラー'}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div> */}
      <form onSubmit={handleFormSubmit}>
        <div className="flex flex-col">
          <div className="flex w-[1500px] flex-col">
            <Tabs
              defaultSelectedKey="basic-info"
              selectedKey={tabKey}
              onSelectionChange={setTabKey}
              className="w-full"
            >
              <TabList
                aria-label="Support Plan Information"
                className="mb-4 flex border-b border-gray-200"
              >
                <Tab
                  id="basic-info"
                  className="px-8 py-2 text-gray-600 focus:outline-none data-[selected=false]:border-transparent data-[selected=true]:border-blue-900 data-[selected=true]:text-blue-900"
                >
                  個別支援計画
                </Tab>
                <Tab
                  id="appendix"
                  className="px-8 py-2 text-gray-400 focus:outline-none data-[selected=false]:border-transparent data-[selected=true]:border-blue-900 data-[selected=true]:text-blue-900"
                >
                  個別支援計画別表
                </Tab>
              </TabList>
              <div className="flex w-[1450px] flex-col">
                <TabPanel
                  id="basic-info"
                  className="p-4"
                >
                  <BasicInfoForm
                    register={register}
                    control={control}
                    errors={errors}
                    childName={childName}
                    creatorName={creatorName}
                    isEdit={isEdit}
                    isDraft={isDraft}
                    onShare={onShare}
                  />
                </TabPanel>
                <TabPanel
                  id="appendix"
                  className="p-4"
                >
                  <AppendixForm
                    register={register}
                    control={control}
                    errors={errors}
                    childName={childName}
                  />
                </TabPanel>
              </div>
            </Tabs>
          </div>
        </div>

        <div className="mt-10 flex flex-row items-center justify-center space-x-2">
          <Button
            type="button"
            size="lg"
            variant="outline"
            onClick={onCancel}
          >
            戻る
          </Button>
          <Button
            type="submit"
            size="lg"
            variant={isValid ? 'solid-fill' : 'disabled'}
            disabled={!isValid}
            onClick={() => {
              console.log('保存ボタンがクリックされました');
            }}
          >
            保存
          </Button>
        </div>
      </form>
    </>
  );
}
